import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ConversationTaskView } from './conversation-tasks.component';

/** Business-owned detail data; the generic task frame knows nothing about places. */
export interface PlaceEnrichmentTaskView extends ConversationTaskView {
  enrichment: { completed: number; total: number };
}

@Component({
  selector: 'app-place-enrichment-task',
  standalone: true,
  imports: [CommonModule, MatProgressBarModule],
  template: `
    <div class="place-progress" *ngIf="progress as p">
      <p>{{ p.completed }} / {{ p.total }} <span>places enriched</span></p>
      <mat-progress-bar mode="determinate" [value]="p.completed / p.total * 100"
        aria-label="Places enriched" [attr.aria-valuetext]="p.completed + ' of ' + p.total + ' places enriched'"></mat-progress-bar>
    </div>`,
  styles: [`
    .place-progress { margin: var(--br-space-3) 0; }
    p { margin: 0 0 var(--br-space-2); font-size: var(--br-font-size-sm); }
    span { color: var(--br-color-muted); }
    mat-progress-bar { --mdc-linear-progress-active-indicator-color: var(--br-color-primary); --mdc-linear-progress-track-color: var(--br-color-border); border-radius: var(--br-radius-sm); }
  `],
})
export class PlaceEnrichmentTaskComponent {
  @Input() task!: ConversationTaskView;

  get progress(): PlaceEnrichmentTaskView['enrichment'] | null {
    if (!('enrichment' in this.task)) return null;
    const value = (this.task as PlaceEnrichmentTaskView).enrichment;
    return value && Number.isFinite(value.completed) && Number.isFinite(value.total)
      && value.total > 0 && value.completed >= 0 && value.completed <= value.total ? value : null;
  }
}
